var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSucces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#0CBF59"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.9996,
    cy: 42.0001,
    r: 36.4,
    fill: "#0CBF59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_4082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6836 36.6731C49.979 35.9636 48.8367 35.947 48.1119 36.6358L39.3337 44.9782L35.3826 41.1659C34.6628 40.4714 33.5192 40.4816 32.812 41.1889C32.0902 41.9106 32.0965 43.0827 32.8259 43.7967L37.9478 48.8101C38.72 49.5659 39.9529 49.5717 40.7322 48.8232L50.6525 39.295C51.3936 38.5832 51.4076 37.4022 50.6836 36.6731ZM42.0003 23.6665C31.8803 23.6665 23.667 31.8798 23.667 41.9998C23.667 52.1198 31.8803 60.3332 42.0003 60.3332C52.1203 60.3332 60.3337 52.1198 60.3337 41.9998C60.3337 31.8798 52.1203 23.6665 42.0003 23.6665ZM42.0003 56.6665C33.897 56.6665 27.3337 50.1032 27.3337 41.9998C27.3337 33.8965 33.897 27.3332 42.0003 27.3332C50.1037 27.3332 56.667 33.8965 56.667 41.9998C56.667 50.1032 50.1037 56.6665 42.0003 56.6665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_4082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucces);
export default __webpack_public_path__ + "static/media/succes.bbe76a4dd6222e2eded658ff2cd65c08.svg";
export { ForwardRef as ReactComponent };